import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';


@Component({
  selector: 'app-account-deleted-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './account-deleted.dialog.html',
  styleUrls: ['./account-deleted.dialog.scss']
})
export class accountDeletedDialog  {
  showConfirmation = true;

  private ref = inject(DynamicDialogRef);
  private dialogService = inject(DialogService);
  private router = inject(Router);

}
